// The native Chat launcher floats outside Horizon's .page-wrapper scroller.
// Yield only when its actual footprint covers these shopping/form surfaces.
// Do not change the shadow DOM, native chat mode, checkout or purchase sizing.
const protectedSurfaces = [
  '.product-details',
  '.tiger-range-directory__card',
  '.tiger-newsletter__form-wrap',
  '.sticky-add-to-cart__bar[data-stuck="true"]',
  '.cart-summary',
].join(',');

function overlaps(a, b, clearance = 12) {
  return a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0 &&
    a.left < b.right + clearance && a.right > b.left - clearance &&
    a.top < b.bottom + clearance && a.bottom > b.top - clearance;
}

customElements.whenDefined('shopify-chat').then(() => {
  const chat = document.querySelector('shopify-chat');
  if (!chat) return;
  let pending = false;
  const update = () => {
    pending = false;
    const launcher = chat.shadowRoot?.querySelector('[part~="activator"]');
    // Fail open if Shopify changes its exposed part. Never hide an open chat
    // or a keyboard-focused launcher; a user must be able to complete that action.
    const focused = launcher && (chat.shadowRoot.activeElement === launcher ||
      launcher.contains(chat.shadowRoot.activeElement));
    let obscures = false;
    if (launcher && !chat.hasAttribute('open') && !focused) {
      const bounds = launcher.getBoundingClientRect();
      obscures = Array.from(document.querySelectorAll(protectedSurfaces)).some(element => {
        const style = getComputedStyle(element);
        return style.visibility !== 'hidden' && style.display !== 'none' &&
          overlaps(bounds, element.getBoundingClientRect());
      });
    }
    chat.toggleAttribute('data-tiger-obscures-content', obscures);
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };

  // Capture catches both normal mobile scrolling and Horizon's desktop scroller.
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify-chat:close', schedule);
  new MutationObserver(schedule).observe(chat, { attributes: true, attributeFilter: ['open', 'mode'] });
  if (chat.shadowRoot) {
    new MutationObserver(schedule).observe(chat.shadowRoot, { childList: true, subtree: true });
  }
  // Asynchronous payment/review/variant rendering can move the protected surfaces.
  const observer = new ResizeObserver(schedule);
  const observeSurfaces = () => {
    document.querySelectorAll(protectedSurfaces).forEach(element => observer.observe(element));
    schedule();
  };
  document.addEventListener('shopify:section:load', observeSurfaces);
  document.addEventListener('shopify:product:select', observeSurfaces);
  observeSurfaces();
});
